import { type SVGProps } from 'react'

/**
 * Timeline: two staggered clips, one per track. Lucide grammar
 * (24 viewBox, 1.75 stroke, currentColor) so it sits next to the stock set.
 */
export function TimelineIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <rect x="3" y="6" width="11" height="5" rx="1.5" />
      <rect x="9" y="13" width="12" height="5" rx="1.5" />
    </svg>
  )
}
